import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

export function useLogout() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { mutate: logout, isPending: isLoading } = useMutation({
    mutationFn: () => localStorage.removeItem("user"),
    onSuccess: () => {
      queryClient.cancelQueries();
      navigate("/login", { replace: true });
    },
  });

  return { logout, isLoading };
}
